<template>
  <div>
    <a-collapse
      ref="refCollapse"
      v-model="activeKey"
      bordered
      class="pca-sales-item"
      :style="{ minWidth: width + 'px' }"
      @change="handleShowDetail(!show_detail, item.fulfillment_id)"
    >
      <a-collapse-panel :key="item.fulfillment_id" :show-arrow="false">
        <template slot="header">
          <div class="list-item">
            <div class="row flex-nowrap align-items-center row-calc fs-13px">
              <div v-if="typeActiveBulkActions" class="col w-8" @click="e => e.stopPropagation()">
                <a-checkbox
                  v-if="showCheckboxBasedOnTypeActiveBulkActions"
                  v-model="item.is_checked"
                  class="fulfillment-checkbox"
                  @change="handleItemCheckedBulkActions"
                />
              </div>
              <div class="col text-truncate">
                <time
                  v-if="item.created_at"
                  class="mw-100 d-inline-block align-middle text-truncate"
                  :title="$moment(item.created_at).format('DD MMM YYYY - HH:mm')"
                >
                  {{ $moment(item.created_at).format('DD MMM YYYY - HH:mm') }}
                </time>
              </div>
              <div class="col text-truncate">
                <time
                  v-if="item.order_date"
                  class="mw-100 d-inline-block align-middle text-truncate"
                  :title="$moment(item.order_date).format('DD MMM YYYY - HH:mm')"
                >
                  {{ $moment(item.order_date).format('DD MMM YYYY - HH:mm') }}
                </time>
              </div>
              <div class="col text-truncate">
                <div
                  class="mw-100 d-inline-block align-middle text-truncate"
                  :title="item.order_number"
                >
                  <a-button
                    type="link"
                    size="small"
                    class="text-dark pl-0"
                    @click="e => {
                      e.stopPropagation()
                      handleCopy($t('fulfillment.orderNo'), item.order_number)
                    }"
                  >
                    <a-icon type="copy" />
                  </a-button>
                  {{ item.order_number }}
                </div>
              </div>
              <div class="col text-truncate">
                <div
                  v-if="item.fulfillment_number"
                  class="mw-100 d-inline-block align-middle text-truncate"
                  :title="item.fulfillment_number"
                >
                  <a-button
                    v-if="item.fulfillment_number"
                    type="link"
                    size="small"
                    class="text-dark pl-0"
                    @click="e => {
                      e.stopPropagation()
                      handleCopy($t('fulfillment.shippingId'), item.fulfillment_number)
                    }"
                  >
                    <a-icon type="copy" />
                  </a-button>
                  {{ item.fulfillment_number || '-' }}
                </div>
              </div>
              <div class="col text-truncate">
                <div
                  v-if="item.business_name"
                  class="mw-100 d-inline-block align-middle text-truncate"
                  :title="item.business_name"
                >
                  {{ item.business_name }}
                </div>
              </div>
              <div class="col text-truncate">
                <div
                  v-if="item.channel_name"
                  class="mw-100 d-inline-block align-middle text-truncate"
                  :title="item.channel_name"
                >
                  {{ item.channel_name }}
                </div>
              </div>
              <div class="col text-truncate">
                <div
                  class="mw-100 d-inline-block align-middle text-truncate"
                  :title="findWarehouseNameById"
                >
                  {{ findWarehouseNameById }}
                </div>
              </div>
              <div class="col text-truncate" style="max-width: 10% !important; flex-basis: 10% !important;">
                {{ item.items }}
              </div>
              <div class="col text-truncate">
                <div
                  class="mw-100 d-inline-block align-middle text-truncate"
                  :title="serviceName"
                >
                  {{ serviceName }}
                </div>
              </div>
              <div class="col text-truncate">
                <div
                  v-if="item.sla"
                  class="mw-100 d-inline-block align-middle text-truncate"
                  :title="slaDateTime"
                >
                  <a-button
                    shape="round"
                    size="small"
                    class="booking-state unallocated-state px-2 ml-auto fs-13px"
                  >
                    {{ slaDateTime }}
                  </a-button>
                </div>
              </div>
              <div class="col text-truncate">
                <a-button
                  v-if="bookingStatus.title"
                  shape="round"
                  size="small"
                  :class="[bookingStatus.class, 'booking-state px-2 ml-auto fs-13px w-100']"
                >
                  {{ bookingStatus.title }}
                </a-button>
              </div>
              <div class="col px-1 align-items-center" style="max-width: 21% !important; flex-basis: 21% !important;">
                <a-button
                  shape="round"
                  size="small"
                  class="text-white px-2 mr-auto fs-10px w-100"
                  :style="{ background: getBackgroundColorStatus }"
                >
                  {{ wordingFulfillmentState }}
                </a-button>
              </div>
              <div class="" style="width: 60px !important; position: sticky; right: 0; background: #fafafa;">
                <a-dropdown placement="bottomRight">
                  <a-button
                    type="link"
                    size="small"
                    class="text-dark font-weight-bold px-0"
                    style="font-size: 20px; line-height: 0"
                    @click="e => e.stopPropagation()"
                  >
                    <a-icon type="more" />
                  </a-button>
                  <a-menu slot="overlay">
                    <a-menu-item @click="handleShowDetail(!show_detail, item.fulfillment_id)">
                      {{ show_detail ? $t('fulfillment.closeDetail') : $t('fulfillment.viewDetail') }}
                    </a-menu-item>
                    <a-menu-item
                      v-if="
                        permission.includes('WRITE') &&
                          (item?.order_state === 'SUBMITTED' || item?.order_state === 'CREATED' || item?.order_state === 'CONFIRMED') && (item?.delivery_order_state !== 'DELETED' || item?.fulfillment_state !== 'DELETED')
                      "
                      @click="onAccepted(item)"
                    >
                      {{ $t('order.accept_order') }}
                    </a-menu-item>
                    <a-menu-item
                      v-if="['accepted'].includes(item?.delivery_order_state?.toLowerCase()) 
                        && (permission.includes('EDIT') || permission.includes('WRITE'))
                        && !item.is_ext_wms"
                      @click="() => $emit('setModalInformationProcessingState', {
                        show: true,
                        businessId: item.business_id,
                        orderId: item.order_id,
                        fulfillmentId: item.fulfillment_id,
                        state: item?.delivery_order_state?.toLowerCase(),
                        action: 'pick-confirmed',
                      })"
                    >
                      {{ $t('fulfillment.picked') }}
                    </a-menu-item>
                    <a-menu-item
                      v-if="item?.delivery_order_state?.toLowerCase() === 'pick_confirmed' 
                        && (permission.includes('EDIT') || permission.includes('WRITE'))
                        && !item.is_ext_wms"
                      @click="() => $emit('setModalInformationProcessingState', {
                        show: true,
                        businessId: item.business_id,
                        orderId: item.order_id,
                        fulfillmentId: item.fulfillment_id,
                        state: item?.delivery_order_state?.toLowerCase(),
                        action: 'pack-confirmed',
                      })"
                    >
                      {{ $t('fulfillment.packed') }}
                    </a-menu-item>
                    <a-menu-item
                      v-if="['packing_completed'].includes(item?.delivery_order_state?.toLowerCase()) 
                        && (permission.includes('EDIT') || permission.includes('WRITE'))
                        && !item.is_ext_wms"
                      @click="() => $emit('setModalInformationProcessingState', {
                        show: true,
                        businessId: item.business_id,
                        orderId: item.order_id,
                        fulfillmentId: item.fulfillment_id,
                        state: item?.delivery_order_state?.toLowerCase(),
                        action: 'packing-completed',
                      })"
                    >
                      {{ $t('fulfillment.readyToShip') }}
                    </a-menu-item>
                    <a-menu-item
                      v-if="((item.delivery_order_state?.toLowerCase() || '') == 'good_issued') 
                        && (permission.includes('EDIT') || permission.includes('WRITE'))
                        && !marketplaces.includes(item.channel_code)"
                      @click="() => $emit('setModalInformationProcessingState', {
                        show: true,
                        businessId: item.business_id,
                        orderId: item.order_id,
                        fulfillmentId: item.fulfillment_id,
                        state: item?.delivery_order_state?.toLowerCase(),
                        action: 'good-issued',
                      })"
                    >
                      {{ $t('fulfillment.shipped') }}
                    </a-menu-item>
                    <a-menu-item
                      v-if="((item.delivery_order_state?.toLowerCase() || '') == 'shipped') 
                        && (permission.includes('EDIT') || permission.includes('WRITE'))
                        && !marketplaces.includes(item.channel_code)"
                      @click="() => $emit('setModalInformationProcessingState', {
                        show: true,
                        businessId: item.business_id,
                        orderId: item.order_id,
                        fulfillmentId: item.fulfillment_id,
                        state: item?.delivery_order_state?.toLowerCase(),
                        action: 'shipped',
                      })"
                    >
                      {{ $t('fulfillment.sent') }}
                    </a-menu-item>
                    <a-menu-item
                      v-if="['accepted'].includes(item?.delivery_order_state?.toLowerCase()) 
                        && (permission.includes('EDIT') || permission.includes('WRITE'))
                        && !item.is_ext_wms"
                      @click="() => $emit('setModalInformationProcessingState', {
                        show: true,
                        businessId: item.business_id,
                        orderId: item.order_id,
                        fulfillmentId: item.fulfillment_id,
                        state: item?.delivery_order_state?.toLowerCase(),
                        action: 'packing-completed',
                      })"
                    >
                      {{ $t('fulfillment.readyToShip') }}
                    </a-menu-item>
                    <a-menu-item
                      v-if="isEligibleForPrintLabel
                        && (permission.includes('EDIT') || permission.includes('WRITE'))"
                      @click="() => $emit('setShowModalPrintLabel', {
                        show: true,
                        businessId: item.business_id,
                        orderId: item.order_id,
                        orderNumber: item.order_number,
                        channelCode: item.channel_code,
                        fulfillmentId: item.fulfillment_id,
                        state: item?.delivery_order_state?.toLowerCase(),
                        action: 'print-label',
                      })"
                    >
                      {{ $t('fulfillment.printLabel') }}
                    </a-menu-item>
                    <a-menu-item
                      v-if="
                        ['tiktok', 'tiktok_id', 'tiktok_tokopedia'].includes(item.channel_code)
                          && ['pick_confirmed', 'packing_completed', 'good_issued', 'shipped'].includes(item.delivery_order_state?.toLowerCase())
                          && (permission.includes('EDIT') || permission.includes('WRITE'))
                      "
                      :disabled="loadingUpdatePackage"
                      @click="onClickUpdatePackage(item)"
                    >
                      <a-icon v-if="loadingUpdatePackage" type="loading" class="mr-1" />
                      {{ $t('fulfillment.update_package') }}
                    </a-menu-item>
                    <!-- <a-menu-item
                      v-if="['confirmed', 'accepted', 'pick_confirmed', 'packing_completed'].includes(item.fulfillment_state.toLowerCase())
                        && (permission.includes('EDIT') || permission.includes('WRITE'))"
                      @click="() => $emit('setModalInformationProcessingState', {
                        show: true,
                        orderId: item.order_id,
                        fulfillmentId: item.fulfillment_id,
                        state: item.fulfillment_state.toLowerCase(),
                        action: 'reject-order', // please set based on modal nedeed
                        channelCode: item.channel_code,
                        business_id: item.business_id,
                      })"
                    >
                      Batalkan
                    </a-menu-item> -->
                    <a-menu-item
                      v-if="['accepted', 'pick_confirmed', 'packing_completed', 'good_issued'].includes(item.delivery_order_state?.toLowerCase())
                        && (permission.includes('EDIT') || permission.includes('WRITE')) && item.channel_code === 'tokopedia_id'"
                      @click="() => handleVisible(true, item)"
                    >
                      {{ item.is_automatic_awb ? $t('fulfillment.changeAwb') : $t('fulfillment.enterAwb') }}
                    </a-menu-item>
                    <a-menu-item
                      v-if=" ['created', 'confirmed', 'accepted', 'pick_confirmed', 'packing_completed'].includes(item.delivery_order_state?.toLowerCase())
                        && (permission.includes('EDIT') || permission.includes('WRITE'))"
                      @click="onClickRevision(item)"
                    >
                      {{ $t('fulfillment.reviseDeliveryOrder') }}
                    </a-menu-item>
                    <a-menu-item
                      v-if="
                        permission.includes('WRITE') &&
                          ['CREATED', 'ACCEPTED'].includes(item.delivery_order_state?.toUpperCase()) &&
                          ['SUBMITTED', 'ACCEPTED'].includes(item.order_state?.toUpperCase())
                      "
                      @click="onClickCancelOrder(item)"
                    >
                      {{ ['CANCELREQUESTED', 'CANCEL_REQUESTED'].includes(item.delivery_order_state?.toUpperCase()) ? $t('order.accept_cancel_order') : $t('order.cancel_order') }}
                    </a-menu-item>
                  </a-menu>
                </a-dropdown>
              </div>
            </div>
          </div>
        </template>
        <div
          v-if="show_detail"
          class="mb-3"
        >
          <router-view :fulfillment_id="item.fulfillment_id" />
        </div>
      </a-collapse-panel>
    </a-collapse>
    <a-modal
      :title="rowData.is_automatic_awb ? $t('fulfillment.changeAwb') : $t('fulfillment.inputAwb')"
      :visible="visible"
      :loading="isLoadingAwb"
      @ok="submitAwb"
      @cancel="() => handleVisible(false, {})"
    >
      <a-input v-model="manual_awb" :placeholder="$t('fulfillment.enterAwb')" />
    </a-modal>
  </div>
</template>

<script>
import { confirmShippingTokopedia } from '@/api/channels/tokopedia'
import {
  urlToDetailFulfillment,
  getUrlAfterDetailFulfillment,
  setBackgroundColorStatus,
  setWordingBookingState,
  setWordingFulfillmentState,
} from '@/utils/fulfillment/index'

export default {
  name: 'FulfillmentItem',
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    itemNum: {
      type: Number,
      default: 0,
    },
    itemChecked: {
      type: Boolean,
      default: () => false,
    },
    position: {
      type: Object,
      default: () => {},
    },
    activeCategories: {
      type: String,
      default: () => ('' || 'all'),
    },
    permission: {
      type: Array,
      default: () => {},
    },
    width: {
      type: Number,
      default: 1190,
    },
    warehouseList: {
      type: Array,
      default: () => [],
    },
    typeActiveBulkActions: {
      type: String,
      default: () => ('' || null),
    },
    bulkOrderState: {
      type: Array,
      default: () => ['CREATED', 'CONFIRMED'],
    },
    serviceList: {
      type: Array,
      default: () => [],
    },
  },
  data: function () {
    return {
      activeKey: this.$route.query.fulfillment_id ? this.$route.query.fulfillment_id.split(',') : [],
      show_detail: false,
      show_reject: false,
      modalQuery: '',
      minimal_length_slicing_word: 10,
      visible: false,
      rowData: {},
      manual_awb: '',
      isLoadingAwb: false,
      isChecked: false,
      marketplaces: ['blibli_id', 'lazada_id', 'shopee_id', 'tiktok', 'tiktok_id', 'tokopedia_id'],
      loadingUpdatePackage: false,
    }
  },
  computed: {
    showCheckboxBasedOnTypeActiveBulkActions() {
      switch (this.typeActiveBulkActions) {
        case 'submit-to-wms':
          if (this.item.show_box) {
            return true
          }
          return false
        case 'print-shipping-label':
          if (['PICK_CONFIRMED', 'PACKING_COMPLETED', 'GOOD_ISSUED', 'SHIPPED', 'DELIVERED', 'BUYER_ACCEPTED'].includes(this.item?.delivery_order_state?.toUpperCase())) {
            return true
          }
          return false
        case 'bulk-process':
          const statuses1 = ['DELIVERED', 'BUYER_ACCEPTED'];
          const checkAllExist1 = (arr, subArr) => subArr.every(item => arr.includes(item));
          if (['offline'].includes(this.item?.channel_code?.toLowerCase()) && checkAllExist1(statuses1, this.bulkOrderState) && !this.item.is_ext_wms) {
            if (['BUYER_ACCEPTED'].includes(this.item?.delivery_order_state?.toUpperCase())) {
              return false
            }
            return true
          }
          const statuses2 = ['GOOD_ISSUED', 'SHIPPED', 'DELIVERED', 'BUYER_ACCEPTED'];
          const checkAllExist2 = (arr, subArr) => subArr.every(item => arr.includes(item));
          if (!['offline', 'distributor', 'store'].includes(this.item?.channel_code?.toLowerCase()) && checkAllExist2(statuses2, this.bulkOrderState)) {
            return false
          }
          if (['CREATED', 'CONFIRMED'].includes(this.item?.delivery_order_state?.toUpperCase()) || (!this.item.is_ext_wms && this.bulkOrderState.includes(this.item?.delivery_order_state?.toUpperCase()))) {
            return true
          }
          return false
        case 'print-picking-list':
          if (!['CANCELED'].includes(this.item?.delivery_order_state?.toUpperCase())) {
            return true
          }
          return false
        default:
          return true
      }
    },
    isEligibleForPrintLabel() {
      if (['PICK_CONFIRMED', 'PACKING_COMPLETED', 'GOOD_ISSUED', 'SHIPPED', 'DELIVERED', 'BUYER_ACCEPTED'].includes(this.item?.delivery_order_state?.toUpperCase())) {
          return true
        }
        return false
    },
    getBackgroundColorStatus() {
      const deliveryState = (this.item.delivery_order_state || '').toLowerCase()
      const orderState = (this.item.order_state || '').toUpperCase()
      if (['return_requested', 'cancel_requested'].includes(deliveryState) && orderState === 'CANCELED') {
        return setBackgroundColorStatus('canceled')
      }
      return setBackgroundColorStatus(this.item.delivery_order_state)
    },
    wordingBookingState: function () {
      return this.bookingStatus.title
    },
    bookingStatus() {
      const state = (this.item.booking_state || '').toUpperCase()
      const states = {
        BOOKED: { title: this.$t('fulfillment.booked'), class: 'allocated-state' },
        ALLOCATED: { title: this.$t('fulfillment.booked'), class: 'allocated-state' },
        SUCCESS_ALLOCATED: { title: this.$t('fulfillment.booked'), class: 'allocated-state' },
        ALLOCATION_RELEASED: { title: this.$t('fulfillment.booked'), class: 'allocated-state' },
        NOT_YET_ALLOCATED: { title: this.$t('fulfillment.pending'), class: 'unallocated-state' },
        ALLOCATION_FAILED: { title: this.$t('fulfillment.oos'), class: 'oos-state' },
        OUT_OF_STOCK: { title: this.$t('fulfillment.oos'), class: 'oos-state' },
        OOS: { title: this.$t('fulfillment.oos'), class: 'oos-state' },
      }
      return states[state] || { title: state, class: '' }
    },
    wordingFulfillmentState: function () {
      const value = (this.item.delivery_order_state || '').toLowerCase()
      if (['confirmed', 'created'].includes(value)) return this.$t('fulfillment.new')
      if (['split_shipment', 'split_fulfillment'].includes(value)) return this.$t('fulfillment.separate_shipment')
      if (['accepted'].includes(value)) return this.$t('fulfillment.do_process')
      if (['pick_confirmed'].includes(value)) return this.$t('fulfillment.picking')
      if (['packing_completed'].includes(value)) return this.$t('fulfillment.packing')
      if (['good_issued'].includes(value)) return this.$t('fulfillment.ready_to_ship')
      if (['shipped'].includes(value)) return this.$t('fulfillment.in_delivery')
      if (['delivered', 'buyer_accepted'].includes(value)) return this.$t('fulfillment.delivered')
      if (['canceled', 'good_issued_canceled', 'deleted'].includes(value)) return this.$t('fulfillment.canceled')
      if (['return_requested'].includes(value)) {
        if ((this.item.order_state || '').toUpperCase() === 'CANCELED') return this.$t('fulfillment.canceled')
        return this.$t('fulfillment.return_requested')
      }
      if (['returned'].includes(value)) return this.$t('fulfillment.returned')
      if (['cancel_requested'].includes(value)) {
        if ((this.item.order_state || '').toUpperCase() === 'CANCELED') return this.$t('fulfillment.canceled')
        return this.$t('fulfillment.cancel_requested')
      }
      return value
    },
    getUrlToDetailFulfillment: function () {
      return urlToDetailFulfillment({
        meta_key_url: this.$route.meta.key,
        id: this.$route.params.id,
        channel_type: this.$route.params.channelType,
      })
    },
    getUrlAfterDetailFulfillmentPage: function () {
      return getUrlAfterDetailFulfillment({
        meta_key_url: this.$route.meta.key,
        id: this.$route.params.id,
        channel_type: this.$route.params.channelType,
      })
    },
    isMasterFulfillment: function () {
      return (
        this.$route.meta.key === 'fulfillment' ||
        this.$route.meta.key === 'fulfillment-detail'
      )
    },
    isHaveActionButton () {
      const fulfillmentState = (this.item.delivery_order_state || '')?.toLowerCase()
      if (
        [
          'created',
          'pick_confirmed',
          'packing_completed',
        ].includes(fulfillmentState)
      ) {
        this.$emit('setHaveActionButton', true)
        return true
      } else {
        this.$emit('setHaveActionButton', false)
        return false
      }
    },
    warehouse_list() {
      if (this.warehouseList?.length > 0) {
        const listWhs = []
        this.warehouseList.forEach(item => {
          listWhs.push({
            value: item?.id || item?.warehouse_id,
            label: item.name,
          })
        })
        listWhs.unshift(
          {
            "label": this.$t('fulfillment.allWarehouses'),
            "value": "ALL",
          },
        )
        return listWhs
      }
      return []
    },
    findWarehouseNameById() {
      const findWhs = this.warehouse_list.find((whs) => whs.value === this.item.warehouse_id)
      return findWhs?.label ? findWhs.label : '-'
    },
    slaDateTime() {
      if (this.item?.sla) {
        const value = this.item.sla < 1e12 ? this.item.sla * 1000 : this.item.sla
        return this.$moment(value).format('DD MMM YYYY - HH:mm')
      }

      return ''
    },
    serviceName() {
      const findService = this.serviceList.find(service => service.value == this.item.fulfillment_priority_level)
      return findService?.label || '-'
    },
  },
  watch: {
    // item: {
    //   immediate: true,
    //   deep: true,
    //   handler: function (value) {
    //     if (
    //       value &&
    //       this.$route.query.fulfillment_id &&
    //       this.$route.query.fulfillment_id
    //         .split(',')
    //         .find((item) => item === value.fulfillment_id)
    //     ) {
    //       this.show_detail = true
    //     }
    //     if(value.show_box) {
    //       this.isChecked = value.is_checked
    //     }
    //   },
    // },
    '$route.query'(newValue, oldValue) {
      if (newValue.delivery_order_states !== oldValue.delivery_order_states) {
        this.show_detail = false
      }
    },
  },
  methods: {
    onAccepted(data) {
      this.$emit('onClickAccepted', data)
    },
    onClickRevision(data) {
      this.$emit('onClickRevision', data)
    },
    onClickCancelOrder(data) {
      this.$emit('onClickCancelOrder', data)
    },
    onClickUpdatePackage(data) {
      this.$emit('onClickUpdatePackage', data)
    },
    async submitAwb() {
      this.isLoadingAwb = true
      try {
        await confirmShippingTokopedia({
          order_id: this.rowData.order_id,
          business_id: this.$route.query.business_id,
          data: { awb: this.manual_awb },
        })
      } catch (err) {
        console.error({err})
        this.$message.error(this.$t('fulfillment.awbSaveFailed'), 5)
        throw err
      } finally {
        this.isLoadingAwb = false
        this.handleVisible(false, {})
        this.manual_awb = ''
      }
    },
    handleVisible(param, item) {
      this.visible = param
      this.rowData = item
    },
    handleItemCheckedBulkActions(e) {
      this.$emit('onCheckBulkActions', {
        index: this.itemNum,
        checked: e.target.checked,
        item: this.item,
      })
    },
    handleItemSubmitted(e) {
      this.$emit('handleItemSubmitted', {
        index: this.itemNum,
        checked: e.target.checked,
        item: this.item,
      })
    },
    handleShowDetail: function (value, fulfillment_id) {
      const yAxis = window.top.scrollY
      // Get data fulfillment id dari router.
      const { fulfillment_id: routeQueryFulfillmentId } = this.$route.query

      // check condition state show detail
      if (value) {
        // if true => open detail
        this.$router.push({
          path: this.getUrlToDetailFulfillment,
          query: {
            ...this.$route.query,
            // jika di routenya sudah ada list-list detail yang udah kebuka, ditambahkan dengan detail yang terbaru dari param fulfillment_id
            // jika belum ada detail, param fulfillment_id tersebut akan menjadi route di awal.
            fulfillment_id: routeQueryFulfillmentId ? [...routeQueryFulfillmentId.split(','), fulfillment_id].join(',') : fulfillment_id,
          },
        }).then(() => window.scrollTo(0, yAxis))
      } else {
        // if else => unshow detail

        // check fulfillment id yang masih exist di ketika param di filter dengan param fulfillment_id yang akan di unshow
        const fulfillment_id_exist = routeQueryFulfillmentId && routeQueryFulfillmentId.split(',').filter((item) => item !== fulfillment_id)

        if (!fulfillment_id_exist || !fulfillment_id_exist.length) {
          const query = this.$route.query
          delete query.fulfillment_id

          this.$router.push({
            path: this.getUrlAfterDetailFulfillmentPage,
            query,
          }).then(() => window.scrollTo(0, yAxis))
        } else {
          // jika masih ada fulfillment id yang masih exist untuk dibuka
          this.$router.push({
            path: this.$route.path,
            query: {
              ...this.$route.query,
              fulfillment_id: fulfillment_id_exist.join(','),
            },
          }).then(() => window.scrollTo(0, yAxis))
        }
      }

      this.activeKey = fulfillment_id ? fulfillment_id.split(',') : []
      this.show_detail = value
    },
    slicingWording(value) {
      if (value.length <= this.minimal_length_slicing_word) {
        return value
      }

      return `${value.slice(0, this.minimal_length_slicing_word)}...`
    },
    handleCopy(type, val) {
      navigator.clipboard.writeText(val)
      this.$notification.success({
        message: `Copied ${type}: ${val}`,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.pca-sales-item:hover {
  border-color: #ff0a54;

  .ant-collapse-item {
    border-bottom-color: #ff0a54;
  }
}

.row-calc > .col {
  padding-left: 9px;
  padding-right: 9px;
  flex-basis: calc(100% / 6); // 100% / 8
  max-width: calc(100% / 6);
}

.col-10p {
  flex-basis: 10%;
  max-width: 10%;
}

.fs-10px {
  font-size: 10px !important;
}

.fs-12px {
  font-size: 12px !important;
}

.fs-13px {
  font-size: 13px !important;
}

.font-1 {
  font-family: Poppins; // font-face
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  white-space: initial;
}

.list-item {
  padding-left: 3px;
  margin-right: -1px;
}

.item {
  margin-bottom: 1.5rem;
  position: static;
  width: 100%;
  height: auto;
  background: #fff;
  border: 1px solid #ccc;
  box-sizing: border-box;
  border-radius: 10px;
  align-items: center;
  padding: 10px;
  font-weight: 500 !important;
  font-size: 14px !important;
  line-height: 21px !important;
  cursor: pointer;
}
.custom_title_ship_text {
  font-family: Poppins;
  font-size: 12px;
  font-weight: 400;
  line-height: 10px;
  white-space: initial;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active di bawah versi 2.1.8 */ {
  opacity: 0;
}
.hr {
  border: none;
  border-top: 2px dotted #eee;
  color: #fff;
  background-color: #fff;
  height: 2px;
}

.red {
  color: red;
}

.refRowDetail {
  max-height: 75vh;
}

.order-list {
  .ant-card-body {
    padding: 0 !important;
    .title {
      padding: .5rem;
      border: 1px solid #d2d2d2;
      box-sizing: border-box;
      border-radius: 8px;
      color: #fff;

      &__content {
        font-family: Open Sans;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 26px;
      }
    }
    .content {
      padding: 1rem;
      font-family: Work Sans;
      font-style: normal;
      font-weight: 500;

      &__title-product {
        font-size: 14px;
        line-height: 16px;
      }

      &__product-support {
        font-size: 10px;
        line-height: 12px;
      }

      &__total-prices {
        font-size: 11px;
        line-height: 13px;
      }

      &__showed-product {
        font-size: 11px;
        line-height: 26px;
      }

      &__calculation {
        &__grand-total {
          background: #eaedec;
          padding: .75rem;
        }

        &__tabs {
          background: #eaedec;
        }

        &__detail-calculation {
          background: #eaedec;
          padding: .75rem;
          border-top: 1px solid #dfdfdf;
          font-family: Work Sans;
          font-style: normal;
          font-size: 11px;
          line-height: 13px;

          .title {
            font-weight: normal;
          }
        }
      }

      &__shipping,
      &__payment {
        &__title {
          font-family: Work Sans;
          font-style: normal;
          font-weight: normal;
          font-size: 14px;
          line-height: 16px;
        }
      }
    }
  }
}
</style>

<style lang="scss">
.pca-sales-item.ant-collapse {
  .ant-collapse-content-box {
    padding-top: 0;
    padding-bottom: 0;
  }

  .ant-collapse-content-active {
    border-top: 0;
  }
}
.w-8 {
  flex-basis: 4% !important;
  max-width: 4% !important;
  -ms-flex-preferred-size: 4% !important;
}
.fulfillment-checkbox .ant-checkbox-inner {
  border-color: #999 !important;
}
</style>
